module.exports = __webpack_public_path__ + "static/media/logo.71a9c378.svg";